import { ReactNode, useState } from 'react';
import { Layout, Row, Col, Flex } from 'antd';
import HeaderBar from '../../../Layout/HeaderBar';
import SideNav from '../../../Layout/SideNav';
import Loader from '../../../components/Loader';
import GoogleMap from '../../../components/GoogleMap';
import dayjs, { Dayjs } from 'dayjs';
import TripCard from './TripCard';
import { LinkOutlined } from '@ant-design/icons';
import DatePickerOverview from './DatePicker';

const { Content } = Layout;

interface Props {
  internalOverview?: ReactNode;
  title: string;
  data: any[];
  centerMap: { lat: number; lng: number };
  loading: boolean;
  selectedDate: Date;
  onDateChange: (date: Dayjs | null, dateString: string) => void;
  boundary?: { north: number; south: number; east: number; west: number };
  trips: any[];
}

function SensorDetails({
  internalOverview,
  title,
  data,
  centerMap,
  loading,
  selectedDate,
  onDateChange,
  trips,
}: // boundary,
Props) {
  const [toggleGrid, setToggleGrid] = useState(false);
  return (
    <>
      <SideNav />
      <Layout>
        <HeaderBar />
        <Content style={{ margin: '24px 24px 0' }}>
          {internalOverview}
          <Row gutter={16}>
            <Col md={24} xs={24} style={{}}>
              <Flex justify="space-between" align="center">
                <h1>{title}</h1>
                <Flex vertical align="end" gap="middle">
                  <a href={`https://wiki.teltonika-gps.com/view/FMT100_LED_status`} target="_blank">
                    <LinkOutlined /> Sensor information
                  </a>
                </Flex>
              </Flex>
            </Col>
            <Col md={14} xs={24} style={{ minHeight: '600px' }}>
              <div style={{ paddingBottom: 16 }}>
                <DatePickerOverview selectedDate={selectedDate} onDateChange={onDateChange} />
              </div>
              {/* // @ts-ignore */}
              {/* {data[0] &&
                                `Køre tid: ${moment
                                    .utc(data[0].logTime.toDate())
                                    .add(2, "hours")
                                    .format("HH:mm:ss")}`}
                            {data[1] &&
                                ` - ${moment
                                    .utc(data[data.length - 1].logTime.toDate())
                                    .add(2, "hours")
                                    .format("HH:mm:ss")}`} */}
              {loading ? (
                <Loader />
              ) : (
                <>
                  {/* <AdminOnly>
                                        <div style={{}}>
                                            <Button
                                                onClick={() =>
                                                    setToggleGrid(!toggleGrid)
                                                }>
                                                Toggle grid
                                            </Button>
                                        </div>
                                    </AdminOnly> */}
                  {data.length > 0 && (
                    // @ts-ignore
                    <GoogleMap
                      data={data}
                      centerMap={centerMap}
                      selectedDate={selectedDate}
                      toggleGrid={toggleGrid}
                      // boundary={boundary}
                    />
                  )}
                </>
              )}
              {!loading && data.length === 0 && <div>Ingen data</div>}
            </Col>
            <Col md={10}>
              {loading ? (
                <Loader />
              ) : (
                <>
                  <div style={{ paddingLeft: 8, paddingTop: 46 }}>
                    <TripCard trips={trips} />
                  </div>
                </>
              )}
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
}

export default SensorDetails;
